import React from 'react';
import { IIconProps } from '../../interfaces';
const LinkedinIcon = (props: IIconProps) => {
  /*w13 h16*/
  return (
      <svg width={props.width} height={props.height} viewBox="0 0 26 25" fill="none" >
          <title>{props.title}</title>

          <path d="M5.96094 24.2197V7.87793H0.521484V24.2197H5.96094Z" fill="black"/>
          <path d="M3.27734 0C5.1377 0 6.2832 1.2207 6.31836 2.82227C6.31836 4.3916 5.1377 5.64746 3.24121 5.64746H3.20605C1.38086 5.64746 0.200195 4.3916 0.200195 2.82227C0.200195 1.2207 1.41602 0 3.27734 0Z" fill="black"/>
          <path d="M25.5752 14.8496C25.5752 9.83008 22.8926 7.49414 19.3135 7.49414C16.4258 7.49414 15.1328 9.08008 14.4111 10.1934V7.87793H8.9707C9.04297 9.41211 8.9707 24.2197 8.9707 24.2197H14.4111V15.0938C14.4111 14.6055 14.4463 14.1182 14.5898 13.7686C14.9824 12.792 15.8779 11.7822 17.3809 11.7822C19.3496 11.7822 20.1367 13.2803 20.1367 15.4766V24.2197H25.5752V14.8496Z" fill="black"/>
      </svg>
  )
};

export default LinkedinIcon;